import ConfirmationModal from '../../components/confirmation-modal';
import PluginAction from '../plugin-action';

/**
 * Basic list action for managing offers. Can be used as a base for list actions of specific offers.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default abstract class AbstractListAction extends PluginAction {
    protected constructor(container: HTMLElement) {
        super(container);
        this.initializeModals();
        this.initializeFilter();
    }

    /**
     * Initializes all modals for confirming certain actions like deleting offers.
     */
    private initializeModals(): void {
        // Initialize modal to create an offer from a template
        const createOfferFromTemplateModal = document.querySelector<HTMLElement>('#createOfferFromTemplateModal');
        if (createOfferFromTemplateModal) {
            const createOfferFromTemplateConfirmation = new ConfirmationModal(createOfferFromTemplateModal);
            createOfferFromTemplateConfirmation.emitter.on('confirm', (link: HTMLLinkElement) => {
                window.location.href = link.href;
            });

            this.container.querySelectorAll<HTMLLinkElement>('[data-action="createOfferFromTemplate"]').forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();
                    createOfferFromTemplateConfirmation.value = link;
                    createOfferFromTemplateConfirmation.show();
                });
            });
        }

        // Initialize modal to create a template from an offer
        const createTemplateFromOfferModal = document.querySelector<HTMLElement>('#createTemplateFromOfferModal');
        if (createTemplateFromOfferModal) {
            const createTemplateFromOfferConfirmation = new ConfirmationModal(createTemplateFromOfferModal);
            createTemplateFromOfferConfirmation.emitter.on('confirm', (link: HTMLLinkElement) => {
                window.location.href = link.href;
            });

            this.container.querySelectorAll<HTMLLinkElement>('[data-action="createTemplateFromOffer"]').forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();
                    createTemplateFromOfferConfirmation.value = link;
                    createTemplateFromOfferConfirmation.show();
                });
            });
        }

        // Initialize modal to remove an offer
        const removeOfferModal = document.querySelector<HTMLElement>('#removeOfferModal');
        if (removeOfferModal) {
            const removeOfferConfirmation = new ConfirmationModal(removeOfferModal);
            removeOfferConfirmation.emitter.on('confirm', (link: HTMLLinkElement) => {
                window.location.href = link.href;
            });

            this.container.querySelectorAll<HTMLLinkElement>('[data-action="removeOffer"]').forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();
                    removeOfferConfirmation.value = link;
                    removeOfferConfirmation.show();
                });
            });
        }

        // Initialize modal to remove a template
        const removeTemplateModal = document.querySelector<HTMLElement>('#removeTemplateModal');
        if (removeTemplateModal) {
            const removeTemplateConfirmation = new ConfirmationModal(removeTemplateModal);
            removeTemplateConfirmation.emitter.on('confirm', (link: HTMLLinkElement) => {
                window.location.href = link.href;
            });

            this.container.querySelectorAll<HTMLLinkElement>('[data-action="removeTemplate"]').forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();
                    removeTemplateConfirmation.value = link;
                    removeTemplateConfirmation.show();
                });
            });
        }
    }

    /**
     * Initializes the filter for searching for offers.
     */
    private initializeFilter(): void {
        const filterForm = this.container.querySelector<HTMLFormElement>('#offer-list-filter');
        if (!filterForm) {
            return;
        }

        const waitingForApprovalCheckbox = filterForm.querySelector<HTMLInputElement>('#filter\\[waitingForApproval\\]');
        if (waitingForApprovalCheckbox) {
            waitingForApprovalCheckbox.addEventListener('change', () => {
                filterForm.submit();
            });
        }
    }
}
